export default "<div id=\"chart\"></div>";